/* Tracarion: holo tilt on product cards (desktop pointer only, respects reduced motion) */
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!fine.matches || reduce.matches) return;

  var MAX_TILT = 7;
  var active = null;
  var frame = null;
  var lastEvent = null;

  function targetFor(node) {
    var card = node.closest && node.closest('.tc-card:not(.tc-card--soldout)');
    return card ? card.querySelector('.card__inner') : null;
  }

  function render() {
    frame = null;
    if (!active || !lastEvent) return;
    var rect = active.getBoundingClientRect();
    var x = (lastEvent.clientX - rect.left) / rect.width;
    var y = (lastEvent.clientY - rect.top) / rect.height;
    x = Math.min(Math.max(x, 0), 1);
    y = Math.min(Math.max(y, 0), 1);
    active.style.setProperty('--tc-rx', ((0.5 - y) * MAX_TILT).toFixed(2) + 'deg');
    active.style.setProperty('--tc-ry', ((x - 0.5) * MAX_TILT).toFixed(2) + 'deg');
    active.style.setProperty('--tc-mx', (x * 100).toFixed(1) + '%');
    active.style.setProperty('--tc-my', (y * 100).toFixed(1) + '%');
  }

  function release(el) {
    if (!el) return;
    el.classList.remove('is-tilting');
    el.style.removeProperty('--tc-rx');
    el.style.removeProperty('--tc-ry');
  }

  document.addEventListener('pointermove', function (event) {
    var el = targetFor(event.target);
    if (el !== active) {
      release(active);
      active = el;
      if (active) active.classList.add('is-tilting');
    }
    if (!active) return;
    lastEvent = event;
    if (!frame) frame = requestAnimationFrame(render);
  }, { passive: true });

  document.addEventListener('pointerleave', function () {
    release(active);
    active = null;
  });
})();
